import Vue from 'vue';
import iView from "view-design";
import axios from "axios";
import { RequestCounter } from './requestCounter';
Vue.use(iView);
var isProduction = process.env.NODE_ENV === "production";
// const CancelToken = axios.CancelToken;
// const source = CancelToken.source();
var CancelToken = axios.CancelToken;
var source = CancelToken.source();
var http = axios.create({
    baseURL: '',
    timeout: 8000,
    headers: {}
});
// 是否携带cookie
http.defaults.withCredentials = true;
http.defaults.headers.common.token = sessionStorage.getItem("tokenTest");
var timeoutModalVisible = false;
var networkErrorModalVisible = false;
var requestCounter = RequestCounter.getInstance();
var increaseCount = function (config) {
    if (config.url) {
        requestCounter.increment(config.url);
    }
};
var decreaseCount = function (config) {
    if (config.url) {
        requestCounter.decrement(config.url);
    }
};
http.interceptors.request.use(function (request) {
    increaseCount(request);
    return request;
});
// 添加响应拦截器
http.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    response.config.cancelToken = source.token;
    decreaseCount(response.config);
    if (response.data.success) {
        return response;
    }
    else {
        if (response.data.tokenValidateError) {
            source.cancel(response.data.message);
            return iView.Modal.error({
                title: "错误",
                content: response.data.message,
                okText: "退出",
                onOk: function () {
                    sessionStorage.clear();
                    window.location.href = "/policy";
                }
            });
        }
        return Promise.reject(response.data.message);
    }
}, function (error) {
    // 对响应错误做点什么
    console.log(error.code, "error");
    decreaseCount(error.config);
    if (error.code === 'ERR_NETWORK' && !networkErrorModalVisible) {
        requestCounter.reset();
        source.cancel();
        networkErrorModalVisible = true;
        iView.Modal.info({
            title: '系统提示',
            content: '网络连接出错，请重试。',
            onOk: function () {
                networkErrorModalVisible = false;
                window.location.reload();
            },
        });
    }
    if (error.code === 'ECONNABORTED' && !timeoutModalVisible) {
        requestCounter.reset();
        source.cancel();
        timeoutModalVisible = true;
        iView.Modal.info({
            title: '系统提示',
            content: '网络连接超时，请重试。',
            onOk: function () {
                timeoutModalVisible = false;
                window.location.reload();
            },
        });
    }
    return Promise.reject(error);
});
export var inRequest = requestCounter.inRequest;
export default {
    http: http,
    inRequest: inRequest
};
